import { ConfirmationDrawer } from "./ConfirmationDrawer";
/* eslint-disable react/jsx-no-literals */

export const SaveConfirmationDrawer = ({
  isVisible,
  onDismiss,
  onSaveAnyways,
}: {
  isVisible: boolean;
  onDismiss: () => void;
  onSaveAnyways: () => void;
}) => (
  <ConfirmationDrawer
    cancelText="Continue Without Saving"
    confirmText="Save Anyway"
    displayInformation={
      <div>
        <h2>Are you sure you want to save?</h2>
        <p>There are no changes in this proposed version.</p>
      </div>
    }
    isVisible={isVisible}
    onConfirm={onSaveAnyways}
    onDismiss={onDismiss}
  />
);
